import { useLayoutMode } from "./LayoutModeContext";
import "./layoutMode.css";

const OPTIONS = [
  { value: "auto", label: "Αυτόματο", title: "Desktop σε οθόνες από 1280px" },
  { value: "desktop", label: "Desktop", title: "Πάντα η προβολή desktop" },
  { value: "classic", label: "Κλασική", title: "Πάντα η κλασική προβολή" },
];

// Segmented control for choosing between the classic and the desktop layout.
const LayoutModeToggle = ({ className = "" }) => {
  const { pref, setPref, canForceDesktop } = useLayoutMode();
  if (!canForceDesktop) return null;

  return (
    <div
      role="radiogroup"
      aria-label="Προβολή"
      className={`layout-mode-toggle ${className}`}
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={pref === opt.value}
          title={opt.title}
          className={pref === opt.value ? "is-active" : ""}
          onClick={() => setPref(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default LayoutModeToggle;
